// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MMoS","footer":"styles_footer__re6oC"};